/** ****************************** Import libs *********************************** */
import {
  postDataApi,
  PostFormDataApi,
  PutFormDataApi,
  postRequesByIdApi,
  uploadFile,
} from "./action";
import { API_ENDPOINT } from "./urls";
import { hostConfig } from "../config/index";

export const postLoginRequestData = (params) =>
  postDataApi(API_ENDPOINT.login, params);

export const postLogout = (params) =>
  postRequesByIdApi(API_ENDPOINT.logout, params);
/*********************topics********************* */
export const postTopics = (params) => postDataApi(API_ENDPOINT.topics, params);

export const UploadFiles = (params) =>
  uploadFile(API_ENDPOINT.uploadTopic_image, params);
/*********************sub-topics********************* */
export const postSubtopics = (params) =>
  postDataApi(API_ENDPOINT.sub_topic, params);

/************************************bootcamp*************************** */

export const postBootcampModules = (params) =>
  postDataApi(API_ENDPOINT.bootcamp_postmodule, params);

export const postBootcampQuestions = (params) =>
  postDataApi(API_ENDPOINT.bootcamp_postquestion, params);

export const UploadQuestions = (params, id) =>
  uploadFile(API_ENDPOINT.bootcamp_uploadquestion, params, id);
export const CheckFileValidation = (params, id) =>
  uploadFile(API_ENDPOINT.bootcamp_checkFile, params, id);

/************************************drills*************************** */

export const postDrillsModules = (params) =>
  postDataApi(API_ENDPOINT.drills_postmodule, params);

export const postDrillsQuestions = (params) =>
  postDataApi(API_ENDPOINT.drills_postquestion, params);

export const UploadDrillsQuestions = (params, id) =>
  uploadFile(API_ENDPOINT.drills_uploadquestion, params, id);
export const drillsCheckFileValidation = (params, id) =>
  uploadFile(API_ENDPOINT.drills_checkFile, params, id);

/********************************Admin user******************* */

export const postAdminUsers = (params) =>
  postDataApi(API_ENDPOINT.admin, params);
export const PostProfileImg = (params) =>
  uploadFile(API_ENDPOINT.admin_profile, params);

/********************************notes************************** */
export const postNotes = (params) => postDataApi(API_ENDPOINT.notes, params);

/************************mega battle ************************* */
/***********************tests**************************** */
export const postMegaBattleTests = (params) =>
  postDataApi(API_ENDPOINT.megabattle, params);

export const postmegabattleQuestions = (params) =>
  postDataApi(API_ENDPOINT.megabattle_postquestion, params);

export const CheckmegabattleFileValidation = (params, id) =>
  uploadFile(API_ENDPOINT.megabattle_checkFile, params, id);

export const UploadmegabattleQuestions = (params, id) =>
  uploadFile(API_ENDPOINT.megabattle_uploadquestion, params, id);

// ***********************image bank*************************//
export const postImageBank = (params) =>
  postDataApi(API_ENDPOINT.imageBank, params);

export const PostImageBankImg = (params) =>
  uploadFile(`${API_ENDPOINT.imageBank}/upload_image`, params);

// **********************News feed************************//

export const postNewsfeed = (params) =>
  postDataApi(API_ENDPOINT.newsfeed, params);

export const UploadNewsfeedFiles = (params) =>
  uploadFile("newsfeed/upload_image", params);

// *****************Html*********************************//

export const postHTML = (params) =>
  postDataApi(API_ENDPOINT.html_convertor, params);

// ********************badges*********************************//
export const postBadges = (params) => postDataApi("rewards/addrewards", params);

export const UploadBadgesImage = (params) =>
  uploadFile(API_ENDPOINT.badges_images, params);

// *********************subscription********************************//
export const postsubscription = (params) =>
  postDataApi(API_ENDPOINT.subscription, params);

export const Override = (params, id) => {
  return postDataApi(API_ENDPOINT.override, params);
};

// *********************credit packs********************************//
export const postCreditPack = (params) =>
  postDataApi(API_ENDPOINT.credit, params);
// ********************Faq*******************************//
export const postFaq = (params) => postDataApi(API_ENDPOINT.faq, params);

// *****************notification**************************//

export const postNotification = (params) =>
  postDataApi(API_ENDPOINT.notification, params);
export const resendNotificationApi = (params) => {
  return postDataApi(API_ENDPOINT.notification_resend, params);
};

// *****************Users**************************//
export const postMobileUser = (params) =>
  postDataApi(API_ENDPOINT.mobileuser, params);

export const addSubscription = (params) =>
  postDataApi(API_ENDPOINT.add_subscription, params);

// ***************************AI & Data ******************************//

export const uploadAiDocs = (params) =>
  PostFormDataApi(API_ENDPOINT.docs_upload, params);

export const uploadAiImages = (params) =>
  PostFormDataApi(API_ENDPOINT.ai_images_upload, params);

export const updateAiImages = (params, id) =>
  PutFormDataApi(`${API_ENDPOINT.ai_images}/${id}`, params);

export const postConfiguration = () =>
  postDataApi(API_ENDPOINT.configuration_post);

export const postQuestionType = (params) =>
  postDataApi(API_ENDPOINT.get_question_prompt, params);

export const postGeneralPrompts = (params) =>
  postDataApi(API_ENDPOINT.general_prompt, params);

export const postProtocols = (params) => PostFormDataApi(API_ENDPOINT.protocols, params);

export const getProtocols = (params) =>
  postDataApi(API_ENDPOINT.protocols, params);

export const retryDocUpload = (id) => postDataApi(`${API_ENDPOINT.docs_retry}/${id}`, {});

export const postSubjectRouting = (params) =>
  postDataApi(API_ENDPOINT.subject_routing, params);

// Deliberately NOT routed through the shared postDataApi()/action.js helpers: their
// responseStatusHandler collapses every 409 into a hardcoded "User Already Exist"
// string without ever reading the real body, which would show a nonsensical error
// for this endpoint's actual 409s ("conversion already running" / "already
// converted"). retry-conversion also raises its errors as a plain-string
// HTTPException detail (not the {message: ...} envelope the rest of the protocols
// API returns via error_handler()), so the real detail is read directly here.
export const retryProtocolConversion = (id) => {
  const authToken =
    typeof window !== "undefined" ? localStorage.getItem("accessToken") : null;
  return fetch(
    `${hostConfig.API_URL}${API_ENDPOINT.protocols}/${id}/retry-conversion`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    },
  )
    .then(async (response) => {
      const body = await response.json().catch(() => null);
      if (response.ok) {
        return { success: true, ...body };
      }
      return {
        success: false,
        status: response.status,
        message:
          typeof body?.detail === "string"
            ? body.detail
            : "Something went wrong. Please try again.",
      };
    })
    .catch(() => ({
      success: false,
      message: "Network error — please try again.",
    }));
};
  